import React, { useEffect, useRef, useState } from "react";

export default function ConfirmModal({
    title,
    message,
    close,
    modalId
}) {

    return (
        <>
            <h2>{title}</h2>
            <p>{message}</p>

            <div style={{ marginTop: 20 }}>
                <button onClick={() => close(false)}>Cancel</button>
                <button
                    onClick={() => close(true)}
                    style={{ marginLeft: 10 }}
                >
                    Confirm
                </button>
            </div>
        </>
    );
}